const ADMIN_AUTH_KEY = 'ug_demo_admin_ok'
const ADMIN_PASSWORD = 'aa321321aa'

export function isAdminAuthed() {
  return sessionStorage.getItem(ADMIN_AUTH_KEY) === '1'
}

export function setAdminAuthed() {
  sessionStorage.setItem(ADMIN_AUTH_KEY, '1')
}

export function clearAdminAuth() {
  sessionStorage.removeItem(ADMIN_AUTH_KEY)
}

export function checkAdminPassword(password) {
  return password === ADMIN_PASSWORD
}
